"use strict";
// @ts-ignore
try {
    self['workbox:precaching:5.1.3'] && _();
}
catch (e) { }
